import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { apiConfig } from '../../../environments/b2c-config';
import { MsalService } from '@azure/msal-angular';
import { DatabaseCacheService } from '../cache/database-cache.service';

@Injectable({
  providedIn: 'root'
})

export class GetSectionService {

  constructor(
    private httpClient: HttpClient,
    private msalService: MsalService,
    private common: DatabaseCacheService
  ) {

  }

  getSection(sectionId : string){

    var headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    
    let user = this.msalService.instance.getActiveAccount();
    let loginUserId = JSON.stringify(user.idTokenClaims['sub']);

    headers = headers.set('LoginUserId', loginUserId)
      .set('Access-Control-Allow-Origin', '*');  

    return this.httpClient.get(`${apiConfig.uri}/licence/${sectionId}`, { headers: headers });

  }

}
